import React, { useCallback, useEffect, useMemo, useState } from "react";
import CAMHeader from "../../../../components/Header/CAMHeader";
import CAMDrawer from "../../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../../components/contsiners/InvestigatorContainer";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import TabsBar from "../../header/TabsNav";
import BreadcrumbsBar from "../../header/BreadcrumbNav";
import Label from "../../../../components/Label/Label";
import "./createGenealogyReport.scss";
import { useNavigate } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchProducedProducts,
  fetchManufacturingSites,
  fetchUnitOperations,
  fetchProductDescription,
  fetchParameters,
  generateGenealogyReport,
  fetchComponents,
  fetchFilteredBatchList,
  saveGenealogyReport,
  fetchGenealogyReportById,
  clearReportData,
  clearFetchParameters,
} from "../../../../redux/genealogy/actions";
import { fetchProductsSitesAndUnitOfOperations } from "../../../../redux/visualization/actions";
import BatchPreview from "../../visualization/batchFIlters/BatchLIstPreview";
import CloseIcon from "@mui/icons-material/Close";
import { setProductSitesUopFilters } from "../../../../redux/shared/actions";
import GenealogyReport from "../report/GenealogyReport";
import { useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CustomStepIcon = ({ active, completed, icon }) => {
  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: active || completed ? "#1976d2" : "#e0e0e0",
        color: "#fff",
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      {icon}
    </Box>
  );
};

const formatDatesLocal = (value) => {
  if (!value) return value;
  const date = new Date(value);
  if (isNaN(date)) return value;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const CreateGenealogyReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const reportId = location?.state?.report_id;
  const mode = location?.state?.mode;
  const status = location?.state?.status;
  const isReadOnly = mode === "view" && status === "Saved";

  console.log(location);

  const genealogyProducedProducts = useSelector(
    (state) => state.genealogy.genealogyProducedProducts?.data || [],
  );

  const genealogyManufacturingSites = useSelector(
    (state) => state.genealogy.genealogyManufacturingSites?.data || [],
  );

  const genealogyUnitOperations = useSelector(
    (state) => state.genealogy.genealogyUnitOperations?.data || [],
  );

  const genealogyProductDescriptions = useSelector(
    (state) => state.genealogy.genealogyProductDescriptions?.data || [],
  );

  const genealogyParameters = useSelector(
    (state) => state.genealogy.genealogyParameters?.data || [],
  );

  const component = useSelector(
    (state) => state.genealogy.genealogyComponents?.data || [],
  );

  const reportDetails = useSelector((state) => state?.genealogy?.reportData);

  const [type, setType] = useState("product");
  const [activeStep, setActiveStep] = useState(0);

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const [filters, setFilters] = useState({
    producedProduct: "",
    manufacturingSite: "",
    unitOperation: [], // ✅ array now
    // productDescription: "",
    productDescription: { id: "", name: "" }, // ✅ FIX
    parameter: { id: "", name: "" }, // ✅ FIX    batchIdList: [],
    component: {
      segment: "",
      material_number: "",
      material_description: "",
    },
  });

  const [previewData, setPreviewData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const [reportData, setReportData] = useState([]); // ✅ local state for report data to be sent on save
  const steps = ["Select Report Details", "View & Download Report"];

  const {
    product = { id: "", name: "" },
    site = { id: "", name: "" },
    unitOfOperation = { id: "", name: "" },
  } = useSelector((state) => state.shared.productSitesUopValues || {});

  const { data = [] } = useSelector((state) => {
    const list = state?.viz?.productsAndSitesList;
    return { data: Array.isArray(list?.data) ? list.data : [] };
  });

  const savedReport = useSelector(
    (state) => state.genealogy.savedReportDetails?.data,
  );

  const productList = useMemo(
    () => data?.map((p) => ({ id: p.product_id, name: p.product_name })),
    [data],
  );

  const sitesList = useMemo(() => {
    if (!product.id) return [];
    const matched = data.find((p) => p.product_id === product.id);
    return (
      matched?.sites?.map((s) => ({ id: s.site_id, name: s.site_name })) || []
    );
  }, [data, product]);

  const unitOfOperationList = useMemo(() => {
    if (!product.id || !site.id) return [];
    const matchedProduct = data.find((p) => p.product_id === product.id);
    const matchedSite = matchedProduct?.sites?.find(
      (s) => s.site_id === site.id,
    );
    return (
      matchedSite?.uom?.map((u) => ({ id: u.unit_op_id, name: u.step_name })) ||
      []
    );
  }, [data, product, site]);

  const [openDraftDialog, setOpenDraftDialog] = useState(false);
  const [reportName, setReportName] = useState("");
  const [saveType, setSaveType] = useState("");
  const [isInitializing, setIsInitializing] = useState(false);

  useEffect(() => {
    dispatch(clearReportData());
    dispatch(clearFetchParameters());
  }, [dispatch]);

  useEffect(() => {
    if (!data.length) {
      dispatch(fetchProductsSitesAndUnitOfOperations());
    }
  }, [dispatch, data.length]);

  // useEffect(() => {
  //   dispatch(fetchProducedProducts());
  // }, [dispatch]);

  useEffect(() => {
    if (reportId && mode === "view") {
      dispatch(fetchGenealogyReportById(reportId));
    }
  }, [reportId, mode, dispatch]);

  useEffect(() => {
    if (mode === "view" && savedReport) {
      mode === "view" && isReadOnly && setIsInitializing(true); // ✅ start loader
      const f = savedReport.filters_used || {};
      const unitOpIds = f.unit_operation_id?.split(",") || [];

      const productObj = {
        id: f.product_id,
        name: f.product_name,
      };

      const siteObj = {
        id: f.site_id,
        name: f.site_name,
      };

      const unitOpNames = f.unit_operation?.split(",") || [];
      const unitOpList = unitOpIds.map((id, index) => ({
        id,
        name: unitOpNames[index],
      }));

      dispatch(
        setProductSitesUopFilters({
          product: productObj,
          site: siteObj,
          unitOfOperation: unitOpList,
        }),
      );

      // ✅ 1. Fetch Product Description
      if (f.product_id && f.site_id && unitOpIds.length) {
        dispatch(
          fetchProductDescription({
            product: { id: f.product_id, name: f.product_name },
            site: { id: f.site_id, name: f.site_name },
            unitOfOperation: unitOpIds,
          }),
        );
      }

      // ✅ 2. Fetch Parameters
      if (f.product_id && f.site_id && unitOpIds.length) {
        const formattedUops = (unitOpIds || []).map((id) => ({ id }));

        dispatch(
          fetchParameters({
            product_id: { id: f.product_id, name: f.product_name },
            site_id: { id: f.site_id, name: f.site_name },
            unit_operation_id: formattedUops,
          }),
        );
      }
    }
  }, [savedReport, mode, dispatch]);

  useEffect(() => {
    if (mode === "view") {
      if (!savedReport) return;

      const f = savedReport.filters_used || {};
      const batchIds = f.selected_batch_ids?.split(",") || [];

      setFilters({
        producedProduct: {
          id: f.product_id,
          name: f.product_name,
        },
        manufacturingSite: {
          id: f.site_id,
          name: f.site_name,
        },
        unitOperation:
          f.unit_operation_id?.split(",")?.map((id, index) => ({
            id,
            name: f.unit_operation.split(",")[index],
          })) || [],

        // productDescription: f.product_description,
        productDescription: {
          id: f.product_description, // if available
          name: f.product_description_name,
        },

        parameter: {
          id: f.parameter_id,
          name: f.parameter,
        },

        batchIdList: f.selected_batch_ids?.split(",") || [],
        // batchIdList: f.selected_batch_ids || [],

        component: {
          segment: f.segment || "",
          material_number: f.component_material || "",
          material_description: f.component_description || "",
        },
      });

      // ✅ Date parsing
      if (f.date_range) {
        const [from, to] = f.date_range.replace("From ", "").split(" to ");

        setDate({
          startDate: new Date(from),
          endDate: new Date(to),
        });
      }

      // ✅ Move to step 2 if already generated
      if (status === "Saved") {
        setReportData(savedReport.rows || []); // ✅ load saved report data into local state
        // setActiveStep(1);
      }

      if (batchIds.length) {
        dispatch(fetchComponents(batchIds));
      }
    }
  }, [savedReport]);

  useEffect(() => {
    const isReady =
      mode === "view" &&
      status === "Saved" &&
      reportData?.length > 0 &&
      filters?.parameter?.name; // important for your issue

    if (isReady) {
      setActiveStep(1);
      setIsInitializing(false); // ✅ stop loader
    }
  }, [reportData, filters, mode, status]);

  useEffect(() => {
    if (mode !== "view" || status === "Draft") {
      setReportData(reportDetails?.data || []);
    }
  }, [reportDetails, mode, status]);

  const updateState = (key, value) => {
    setDate((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleTypeChange = (event, newValue) => {
    if (newValue !== null) setType(newValue);
    if (newValue === "component")
    dispatch(fetchComponents(filters?.batchIdList));
  };

  const onClickBack = () => {
    navigate("/analytics/genealogy");
  };

  const handleCancel = () => {
    navigate("/analytics/genealogy");
  };

  const handleGenerate = async (actionType) => {
    const formatDate = (d) =>
      new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    let payload = {
      product_name: filters.producedProduct.name,
      site_name: filters.manufacturingSite.name,
      unit_operation: filters.unitOperation?.map((item) => item.name).join(","),
      unit_operation_id: filters.unitOperation
        ?.map((item) => item.id)
        .join(","),

      product_description: filters.productDescription.id,
      product_description_name: filters.productDescription.name,
      date: `From ${formatDate(date.startDate)} to ${formatDate(date.endDate)}`,
      selected_batches: filters.batchIdList?.map((item) => item).join(","),
      // selected_batches: filters.batchIdList,

      parameter: filters?.parameter.name,
      parameter_id: filters?.parameter.id,
      component: `Segment - ${filters?.component?.segment}, Material Number - ${filters?.component?.material_number} Material Description - ${filters?.component?.material_description}`,
    };

    if (filters.component?.segment) {
      payload = {
        ...payload,
        segments: [filters.component.segment],
        component_material: filters.component.material_number,
        get_all_segments: false,
      };
    } else {
      payload = {
        ...payload,
        batch_numbers: filters.batchIdList,
        get_all_segments: true,
      };
    }

    try {
      console.log("Generate report", payload);

      const res = await dispatch(generateGenealogyReport(payload));

      if (res && res.success) {
        setActiveStep(1);
      } else {
      }
    } catch (err) {}
  };

  const handleSave = async (actionType) => {
    const formatDate = (d) =>
      new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    let payload = {
      report_name: reportName,
      created_by: localStorage.getItem("userid"),
      status: actionType,
      filters_used: {
        product_id: filters.producedProduct.id, // ✅ ADD THIS
        product_name: filters.producedProduct.name,

        site_id: filters.manufacturingSite.id, // ✅ ADD THIS
        site_name: filters.manufacturingSite.name,

        unit_operation_id: filters.unitOperation
          ?.map((item) => item.id)
          .join(","), // ✅ ADD THIS

        unit_operation: filters.unitOperation
          ?.map((item) => item.name)
          .join(","),

        product_description: filters.productDescription.id,
        product_description_name: filters.productDescription.name,
        date_range: `From ${formatDate(date.startDate)} to ${formatDate(date.endDate)}`,
        selected_batch_ids: filters.batchIdList?.map((item) => item).join(","),
        // selected_batch_ids: filters.batchIdList,

        parameter: filters?.parameter.name,
        parameter_id: filters?.parameter.id,

        segment: filters?.component.segment, // ✅ ADD clean fields
        component_material: filters?.component.material_number,
        component_description: filters?.component.material_description,

        component: `Segment - ${filters?.component.segment}, Material Number - ${filters?.component.material_number} Material Description - ${filters?.component.material_description}`,
      },
    };

    if (filters.component?.segment) {
      payload = {
        ...payload,
        segments: [filters.component.segment],
        component_material: filters.component.material_number,
        get_all_segments: false,
      };
    } else {
      payload = {
        ...payload,
        batch_numbers: filters.batchIdList,
        get_all_segments: true,
      };
    }

    if (actionType === "Saved") {
      payload = {
        ...payload,
        // selected_columns: selectedColumns,
        rows: reportData, // ✅ send current report data for saved reports
      };
    }

    try {
      console.log("Generate report", payload);

      const res = await dispatch(saveGenealogyReport(payload));

      if (res && res.success) {
        navigate("/analytics/genealogy");
      } else {
        navigate("/analytics/genealogy", {
          state: {
            reportId: res.data.report_id,
          },
        });
        console.error("Report generation failed", res);
      }
    } catch (err) {
      navigate("/analytics/genealogy", {
        state: {
          // reportId: res.data.report_id,
        },
      });
    }
  };

  const handleFilterChange = (key, value) => {
    const childResets = resetChildFilters(key);

    const updatedFilters = {
      ...filters,
      [key]: value,
      ...childResets,
    };

    setFilters(updatedFilters);

    switch (key) {
      case "producedProduct":
        dispatch(
          setProductSitesUopFilters({
            product: value,
            site: { id: "", name: "" },
            unitOfOperation: { id: "", name: "" },
          }),
        );
        break;

      case "manufacturingSite":
        dispatch(
          setProductSitesUopFilters({
            product,
            site: value,
            unitOfOperation: { id: "", name: "" },
          }),
        );
        break;

      case "unitOperation":
        dispatch(
          fetchProductDescription({
            product: updatedFilters.producedProduct,
            site: updatedFilters.manufacturingSite,
            unitOfOperation: value.map((v) => v.id), // ✅ send array of IDs
          }),
        );
        break;

      case "productDescription":
        dispatch(
          fetchParameters({
            product_id: updatedFilters.producedProduct,
            site_id: updatedFilters.manufacturingSite,
            unit_operation_id: updatedFilters.unitOperation,
          }),
        );
        break;

      default:
        break;
    }
  };

  const resetChildFilters = (key) => {
    const resetMap = {
      producedProduct: {
        manufacturingSite: "",
        unitOperation: [], // ✅ FIX
        productDescription: { id: "", name: "" }, // ✅ FIX
        parameter: { id: "", name: "" },
      },
      manufacturingSite: {
        unitOperation: [], // ✅ FIX
        productDescription: { id: "", name: "" }, // ✅ FIX
        parameter: { id: "", name: "" },
      },
      unitOperation: {
        productDescription: { id: "", name: "" },
        parameter: { id: "", name: "" },
      },
      productDescription: {
        parameter: { id: "", name: "" },
      },
    };

    return resetMap[key] || {};
  };

  const onClickPreview = async () => {
    const payload = {
      unitOfOperation: filters.unitOperation,
      start_date: formatDatesLocal(date?.startDate),
      end_date: formatDatesLocal(date?.endDate),
    };

    const response = await dispatch(fetchFilteredBatchList(payload));
    if (response) {
      setPreviewData(response.map((b) => ({ ...b, isSelected: true })));
    }

    setShowPreview(true);
  };

  const onClickApply = useCallback((ids, closePreview) => {
    console.log(previewData);
    setFilters((prevData) => ({
      ...prevData,
      batchIdList: ids,
    }));

    if (closePreview) setShowPreview(false);
  }, []);

  const flattenedComponents = component.flatMap((seg) =>
    seg?.components?.map((comp) => ({
      segment: seg.segment,
      material_number: comp.material_number,
      material_description: comp.material_description,
    })),
  );

  return (
    <div>
      <CAMHeader />
      <CAMDrawer />

      <InvestigatorContainer>
        <Box
          sx={{
            minHeight: "calc(100vh - 64px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* CONTENT */}
          <Box sx={{ flex: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TabsBar />
              </Grid>
            </Grid>

            <Divider sx={{ mx: 2 }} />

            <Grid item xs={12}>
              <BreadcrumbsBar showBack onClickBack={onClickBack} />
            </Grid>

            <Divider sx={{ mx: 2 }} />

            <Box className="genealogy-step-container">
              {/* Step Header */}
              <Box className="step-header">
                <Stepper
                  activeStep={activeStep}
                  sx={{
                    width: "100%",
                    padding: "0px 16px",
                  }}
                >
                  {steps.map((label, index) => {
                    const isCompleted = index < activeStep;
                    const isActive = index === activeStep;

                    const isClickable =
                      status === "Saved" || index <= activeStep;

                    return (
                      <Step key={index} completed={isCompleted}>
                        <StepLabel
                          StepIconComponent={(props) => (
                            <CustomStepIcon
                              {...props}
                              active={isActive}
                              completed={isCompleted}
                              icon={index + 1}
                            />
                          )}
                          onClick={() => {
                            if (isClickable) {
                              setActiveStep(index);
                            }
                          }}
                          sx={{
                            cursor: isClickable ? "pointer" : "not-allowed",

                            "& .MuiStepLabel-root": {
                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiStepLabel-labelContainer": {
                              order: 1,
                              marginRight: "8px",
                            },
                            "& .MuiStepLabel-iconContainer": {
                              order: 2,
                            },
                            "& .MuiStepLabel-label": {
                              fontWeight: 500,
                            },
                          }}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>

              {isInitializing ? (
                <Box className="loading-container">
                  <CircularProgress />
                </Box>
              ) : // {/* Main Card */}
              activeStep === 0 ? (
                <Paper
                  className="genealogy-form-card"
                  sx={{
                    height: "fit-content",
                    alignSelf: "flex-start",
                    backgroundColor: "#E8EDF4",
                  }}
                >
                  {/* Toggle */}
                  <Box
                    className="field-box-toggle"
                    sx={{ width: "fit-content" }}
                  >
                    <ToggleButtonGroup
                      value={type}
                      exclusive
                      onChange={handleTypeChange}
                      className="type-toggle"
                    >
                      <ToggleButton value="product">Product</ToggleButton>
                      <ToggleButton value="component">Component</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                  {type === "product" ? (
                    <Grid container spacing={2} className="form-grid">
                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label
                            text="Produced Product *"
                            className="field-label"
                          />
                          <Select
                            disabled={isReadOnly}
                            size="small"
                            fullWidth
                            value={filters.producedProduct?.id || ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedItem = productList.find(
                                (item) => item.id === selectedId,
                              );
                              const newValue =
                                selectedId && selectedItem
                                  ? {
                                      id: selectedItem.id,
                                      name: selectedItem.name,
                                    }
                                  : { id: "", name: "" };

                              handleFilterChange("producedProduct", newValue);
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Select Produced Product</em>
                            </MenuItem>

                            {productList.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label
                            text="Manufacturing Site *"
                            className="field-label"
                          />
                          <Select
                            disabled={isReadOnly || !filters.producedProduct}
                            size="small"
                            fullWidth
                            value={filters.manufacturingSite?.id || ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedItem = sitesList.find(
                                (item) => item.id === selectedId,
                              );
                              const newValue =
                                selectedId && selectedItem
                                  ? {
                                      id: selectedItem.id,
                                      name: selectedItem.name,
                                    }
                                  : { id: "", name: "" };

                              handleFilterChange("manufacturingSite", newValue);
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Select Manufacturing Site</em>
                            </MenuItem>

                            {sitesList.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label
                            text="Unit Operation *"
                            className="field-label"
                          />

                          <Select
                            multiple
                            displayEmpty
                            disabled={isReadOnly || !filters.manufacturingSite}
                            size="small"
                            fullWidth
                            value={filters?.unitOperation?.map(
                              (item) => item.id,
                            )}
                            // ✅ ONLY update local state here
                            onChange={(e) => {
                              const selectedIds = e.target.value;

                              const selectedItems = unitOfOperationList.filter(
                                (item) => selectedIds.includes(item.id),
                              );

                              const newValue = selectedItems.map((item) => ({
                                id: item.id,
                                name: item.name,
                              }));

                              setFilters((prev) => ({
                                ...prev,
                                unitOperation: newValue,
                              }));
                            }}
                            onClose={() => {
                              handleFilterChange(
                                "unitOperation",
                                filters.unitOperation,
                              );
                            }}
                            renderValue={(selected) => {
                              if (!selected || selected.length === 0) {
                                return (
                                  <em style={{ color: "#888" }}>
                                    Select Unit Operation
                                  </em>
                                );
                              }

                              const names = unitOfOperationList
                                .filter((item) => selected.includes(item.id))
                                .map((item) => item.name);

                              return names.join(", ");
                            }}
                          >
                            {unitOfOperationList.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                <Checkbox
                                  checked={filters.unitOperation.some(
                                    (selected) => selected.id === item.id,
                                  )}
                                />
                                <ListItemText primary={item.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label
                            text="Product Description *"
                            className="field-label"
                          />
                          <Select
                            disabled={isReadOnly || !filters.unitOperation}
                            size="small"
                            fullWidth
                            // value={filters.productDescription}
                            value={filters.productDescription?.id || ""}
                            // onChange={(e) =>
                            //   handleFilterChange(
                            //     "productDescription",
                            //     e.target.value,
                            //   )
                            // }
                            onChange={(e) => {
                              const selectedId = e.target.value;

                              const selectedItem =
                                genealogyProductDescriptions.find(
                                  (item) => item.material_number === selectedId, // ✅ FIX
                                );

                              const newValue =
                                selectedId && selectedItem
                                  ? {
                                      id: selectedItem.material_number, // ✅ FIX
                                      name: selectedItem.material_description, // ✅ FIX
                                    }
                                  : { id: "", name: "" };

                              handleFilterChange(
                                "productDescription",
                                newValue,
                              );
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Select Product Description</em>
                            </MenuItem>

                            {genealogyProductDescriptions.map((item) => (
                              <MenuItem
                                key={item.material_number}
                                value={item.material_number}
                              >
                                {item.material_description}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label text="Batch *" className="field-label" />

                          <Box
                            className="date-range-picker"
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            {[
                              ["startDate", "From"],
                              ["endDate", "To"],
                            ].map(([key, placeholder]) => (
                              <DatePicker
                                disabled={isReadOnly}
                                key={key}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={50}
                                popperClassName="custom-datepicker-popper"
                                selected={date?.[key] || null}
                                onChange={(selectedDate) =>
                                  updateState(key, selectedDate)
                                }
                                selectsStart={key === "startDate"}
                                selectsEnd={key === "endDate"}
                                startDate={date?.startDate || null}
                                endDate={date?.endDate || null}
                                minDate={
                                  key === "endDate" && date?.startDate
                                    ? date.startDate
                                    : undefined
                                }
                                maxDate={
                                  key === "startDate"
                                    ? date?.endDate || new Date()
                                    : new Date()
                                }
                                placeholderText={placeholder}
                                dateFormat="dd-MMM-yyyy"
                                fixedHeight
                                renderCustomHeader={({
                                  date,
                                  decreaseMonth,
                                  increaseMonth,
                                  changeYear,
                                  prevMonthButtonDisabled,
                                  nextMonthButtonDisabled,
                                }) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      px: 1.5,
                                      py: 1,
                                      bgcolor: "primary.main",
                                      color: "common.white",
                                      borderRadius: "8px 8px 0 0",
                                    }}
                                  >
                                    <IconButton
                                      onClick={decreaseMonth}
                                      disabled={prevMonthButtonDisabled}
                                      sx={{ color: "common.white", p: 0.5 }}
                                      size="small"
                                    >
                                      <ArrowBackIosIcon fontSize="small" />
                                    </IconButton>

                                    <Box
                                      sx={{
                                        mx: 1,
                                        fontWeight: 500,
                                        cursor: "default",
                                        width: 80,
                                        textAlign: "center",
                                      }}
                                    >
                                      <Label
                                        text={date.toLocaleString("default", {
                                          month: "long",
                                        })}
                                        color="#ffff"
                                        fontSize={16}
                                        fontWeight={600}
                                      />
                                    </Box>

                                    <Select
                                      value={date.getFullYear()}
                                      onChange={(e) =>
                                        changeYear(Number(e.target.value))
                                      }
                                      size="small"
                                      onMouseDown={(e) => e.stopPropagation()} // prevent closing
                                      onClick={(e) => e.stopPropagation()} // prevent closing
                                      sx={{
                                        fontSize: 13,
                                        color: "text.primary",
                                        bgcolor: "background.paper",
                                        borderRadius: 1,
                                        // "& .MuiSelect-select": { py: 0.25, px: 1 },
                                      }}
                                    >
                                      {Array.from(
                                        { length: 50 },
                                        (_, i) => new Date().getFullYear() - i,
                                      ).map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                    </Select>

                                    <IconButton
                                      onClick={increaseMonth}
                                      disabled={nextMonthButtonDisabled}
                                      sx={{ color: "common.white", p: 0.5 }}
                                      size="small"
                                    >
                                      <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                )}
                                customInput={
                                  <TextField
                                    size="small"
                                    // fullWidth
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <CalendarTodayIcon fontSize="small" />
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                }
                              />
                            ))}

                            <Button
                              variant="contained"
                              startIcon={<PreviewOutlinedIcon />}
                              disabled={
                                isReadOnly ||
                                !filters.producedProduct?.id ||
                                !filters.manufacturingSite?.id ||
                                filters.unitOperation.length === 0 ||
                                !date.startDate ||
                                !date.endDate
                              }
                              onClick={onClickPreview}
                              sx={{ width: "100px", minWidth: "100px" }}
                            >
                              Preview
                            </Button>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label text="Parameter" className="field-label" />
                          <Select
                            disabled={isReadOnly}
                            size="small"
                            fullWidth
                            value={filters.parameter?.id || ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;

                              const selectedParam = genealogyParameters.find(
                                (p) => p.parameter_id === selectedId,
                              );

                              handleFilterChange("parameter", {
                                id: selectedParam?.parameter_id,
                                name: selectedParam?.parameter_name,
                              });
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Parameter</em>
                            </MenuItem>
                            {genealogyParameters.map((param) => (
                              <MenuItem
                                key={param.parameter_id}
                                value={param.parameter_id}
                              >
                                {`${param.parameter_name} - ${param.step_name}`}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={2} className="form-grid">
                      <Grid item xs={12} md={4}>
                        <Box className="field-box">
                          <Label text="Component" className="field-label" />

                          <Select
                            disabled={isReadOnly}
                            size="small"
                            fullWidth
                            value={filters.component?.material_number || ""}
                            onChange={(e) => {
                              const selected = flattenedComponents.find(
                                (item) =>
                                  item.material_number === e.target.value,
                              );

                              handleFilterChange("component", selected);
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">Component</MenuItem>

                            {flattenedComponents.map((item) => (
                              <MenuItem
                                key={item.material_number}
                                value={item.material_number}
                              >
                                {item.material_description}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </Paper>
              ) : (
                <GenealogyReport
                  data={reportData}
                  parameter={filters.parameter}
                />
              )}
            </Box>
          </Box>

          {/* FOOTER */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "#fff",
              borderTop: "1px solid #dcdcdc",
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 2,
              zIndex: 10,
            }}
          >
            <Box>
              <Button
                variant="outlined"
                disabled={activeStep === 0}
                onClick={() => setActiveStep(0)}
                sx={{
                  ml: 1,
                  "&.MuiButton-root.Mui-disabled": {
                    pointerEvents: "auto !important",
                    cursor: "not-allowed !important",
                    color: "gray !important",
                    borderColor: "lightgray !important",
                    opacity: "1 !important",
                  },
                  "&.Mui-disabled": {
                    color: "gray !important", // text color
                    borderColor: "lightgray  !important", // optional (since outlined button)
                  },
                }}
              >
                Previous Step
              </Button>

              <Button
                variant="outlined"
                onClick={() => setActiveStep(1)}
                disabled={
                  !reportData?.length || activeStep === 1 || !isReadOnly
                }
                sx={{
                  ml: 1,
                  "&.MuiButton-root.Mui-disabled": {
                    pointerEvents: "auto !important",
                    cursor: "not-allowed ",
                    color: "gray !",
                    borderColor: "lightgray !impor",
                    opacity: "1 !important",
                  },
                  "&.Mui-disabled": {
                    color: "gray !important", // text color
                    borderColor: "lightgray  !important", // optional (since outlined button)
                  },
                }}
              >
                Next Step
              </Button>

              <Button
                disabled={
                  isReadOnly ||
                  !filters.producedProduct?.id ||
                  !filters.manufacturingSite?.id ||
                  filters.unitOperation.length === 0
                }
                variant="outlined"
                onClick={() => {
                  setSaveType("Draft");
                  setOpenDraftDialog(true);
                }}
                sx={{
                  ml: 1,
                  "&.MuiButton-root.Mui-disabled": {
                    pointerEvents: "auto !important",
                    cursor: "not-allowed ",
                    color: "gray !",
                    borderColor: "lightgray !impor",
                    opacity: "1 !important",
                  },
                  "&.Mui-disabled": {
                    color: "gray !important", // text color
                    borderColor: "lightgray  !important", // optional (since outlined button)
                  },
                }}
              >
                Save as Draft
              </Button>
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>

              {activeStep === 0 ? (
                <Button
                  variant="contained"
                  onClick={() => handleGenerate("generate")}
                  disabled={
                    isReadOnly ||
                    !filters.producedProduct?.id ||
                    !filters.manufacturingSite?.id ||
                    filters.unitOperation.length === 0 ||
                    !filters.productDescription?.id ||
                    !date.startDate ||
                    !date.endDate ||
                    !filters.batchIdList ||
                    filters.batchIdList.length === 0
                  }
                  sx={{
                    ml: 1,
                    "&.MuiButton-root.Mui-disabled": {
                      pointerEvents: "auto !important",
                      cursor: "not-allowed ",
                      color: "gray !",
                      borderColor: "lightgray !impor",
                      opacity: "1 !important",
                    },
                    "&.Mui-disabled": {
                      color: "gray !important", // text color
                      borderColor: "lightgray  !important", // optional (since outlined button)
                    },
                  }}
                >
                  Generate
                </Button>
              ) : (
                <Button
                  disabled={isReadOnly}
                  variant="contained"
                  onClick={() => {
                    setSaveType("Saved"); // ✅ important
                    setOpenDraftDialog(true); // open same dialog
                  }}
                  sx={{
                    ml: 1,
                    "&.MuiButton-root.Mui-disabled": {
                      pointerEvents: "auto !important",
                      cursor: "not-allowed ",
                      color: "gray !",
                      borderColor: "lightgray !impor",
                      opacity: "1 !important",
                    },
                    "&.Mui-disabled": {
                      color: "gray !important", // text color
                      borderColor: "lightgray  !important", // optional (since outlined button)
                    },
                  }}
                >
                  Save
                </Button>
              )}
            </Box>
          </Box>
        </Box>

        <Dialog
          open={showPreview}
          onClose={() => setShowPreview(false)}
          maxWidth="md"
          fullWidth
          scroll="paper"
          sx={{
            "& .MuiDialog-paper": {
              height: "90vh",
              maxHeight: "90vh",
            },
          }}
        >
          {/* HEADER */}

          {/* CONTENT */}
          <DialogContent
            sx={{
              flex: 1,
              overflow: "auto",
              margin: "0px",
            }}
          >
            <Box
              className="batch-preview-grid-panel"
              sx={{
                marginTop: "0px !important",
                "& .batch-preview-panel": {
                  p: 0,
                  m: 0,
                },
              }}
            >
              <BatchPreview
                showPreview={showPreview}
                setShowPreview={setShowPreview}
                previewData={previewData}
                setPreviewData={setPreviewData}
                onClickApply={onClickApply}
              />
            </Box>
          </DialogContent>
        </Dialog>

        {/* // Save dialog */}
        <Dialog
          open={openDraftDialog}
          onClose={() => setOpenDraftDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>
            {" "}
            {saveType === "Draft" ? "Save Draft" : "Save Report"}
          </DialogTitle>

          <DialogContent>
            <TextField
              label="Report Name"
              fullWidth
              size="small"
              value={reportName}
              onChange={(e) => setReportName(e.target.value)}
              autoFocus
              sx={{ mt: 1 }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenDraftDialog(false)}>Cancel</Button>

            <Button
              variant="contained"
              onClick={() => {
                if (!reportName.trim()) return;

                handleSave(saveType); // ✅ dynamic type
                setOpenDraftDialog(false);
                setReportName("");
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </InvestigatorContainer>
    </div>
  );
};

export default CreateGenealogyReport;
